import { render, staticRenderFns } from "./modal-cms-navigation.vue?vue&type=template&id=38c15142&scoped=true"
import script from "./modal-cms-navigation.vue?vue&type=script&lang=ts"
export * from "./modal-cms-navigation.vue?vue&type=script&lang=ts"
import style0 from "./modal-cms-navigation.vue?vue&type=style&index=0&id=38c15142&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c15142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c15142')) {
      api.createRecord('38c15142', component.options)
    } else {
      api.reload('38c15142', component.options)
    }
    module.hot.accept("./modal-cms-navigation.vue?vue&type=template&id=38c15142&scoped=true", function () {
      api.rerender('38c15142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layout/modal-cms-navigation.vue"
export default component.exports